module.exports = __webpack_public_path__ + "img/bg05.097926da.png";